import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { FormHandles, Scope } from '@unform/core'
import {
  Accordion,
  Breadcrumb,
  Cabecalho,
  Carregando,
  ContainerAcoes,
  ErroLayoutContainer,
  FormUnform,
  IconeBack,
  IconeGerarBoleto,
  IconePix,
  InputUnform,
  Link,
  Spacer,
  Tabela,
  TabelaDados,
  TabelaRef,
  TabelaResposta,
  TemaLinha,
  Tooltip
} from 'src/componentes'
import { Conteudo } from 'src/paginas/ipgs/split-pagamento/cadastro/styles'
import {
  ContainerCheio,
  ContainerGrande,
  ContainerMedio,
  ContainerPequeno,
  Linha
} from 'src/paginas/matricula/styles'
import { Api } from 'src/servicos'
import {
  DetalheDaParcela,
  SituacaoParcela,
  SituacaoParcelaFiltro,
  SituacaoParcelaPosVencimento
} from 'src/tipos'

import { ModalPagamentoParaPix } from '../../painel-financeiro/componentes/modal-pagamento-pix'
import { formatadores } from '../../painel-financeiro/pagina-financeiro/formatadores'
import {
  ContainerDoValorDaTabela,
  TooltipParcelaEmAtrasoComEstilos,
  TooltipParcelaObservacaoComEstilos
} from '../../painel-financeiro/pagina-financeiro/styles'
import { IconeTabela } from '../../painel-financeiro/styles'
import { ModalPagamentoRefPix } from '../../painel-financeiro/tipos'
import { ContainerTabela } from '../requerimentos-solicitados/style'
import { SubMenu, Container, ContainerLink, ContainerMain } from './style'

export const PaginaDetalhesRequerimento: React.FC = () => {
  const history = useHistory()
  const { requerimentoId } = useParams<{ requerimentoId: string }>()
  const formRef = useRef<FormHandles>(null)
  const tabelaRef = useRef<TabelaRef>()

  const [requerimento, definirRequerimento] = useState<any>(null)
  const [matricula, definirMatricula] = useState<string>(null)
  const modalRefPix = useRef<ModalPagamentoRefPix>(null)

  const [pronto, definirPronto] = useState<boolean>(false)

  const parcelaEstaEmAtraso = (parcela: DetalheDaParcela) =>
    parcela.informacoesParcelaAposVencimento.situacaoParcela ===
    SituacaoParcelaPosVencimento.ParcelaEmAtraso

  const parcelaAtiva = (parcela: DetalheDaParcela) =>
    parcela.situacaoParcela !== SituacaoParcela.Cancelado &&
    parcela.situacaoParcela !== SituacaoParcela.Renegociado

  const exibirBotaoPagamento = (situacaoParcela: any) => {
    const situacoes = [
      SituacaoParcela.Cancelado,
      SituacaoParcela.Renegociado,
      SituacaoParcela.Pago,
      SituacaoParcela.AguardandoPagamentoAutomatico
    ]

    if (situacoes.some(x => x === SituacaoParcela[situacaoParcela])) {
      return false
    }

    return true
  }

  const exibirBotaoPagamentoCurso = (situacaoParcela: any) => {
    if (
      situacaoParcela === SituacaoParcelaFiltro.AVencer ||
      situacaoParcela === SituacaoParcelaFiltro.Vencido
    ) {
      return exibirBotaoPagamento(situacaoParcela)
    }
    return false
  }

  const obterDadosTabelaParcelasAtivas = async (): Promise<TabelaResposta | null> => {
    if (!requerimento?.parcela) return null

    const parcela = requerimento.parcela

    const situacoesValidas = [
      'Pago',
      'AguardandoPagamentoAutomatico',
      'Vencido',
      'Negativado',
      'AVencer'
    ]

    if (situacoesValidas.includes(parcela.situacaoParcela)) {
      return {
        Dados: [parcela]
      } as TabelaResposta
    }

    return { Dados: [] } as TabelaResposta
  }

  const gerarBoleto = async (cobrancaId: string) => {
    try {
      definirPronto(false)
      const resposta = await Api.ObterBoletoParaPagamentoDoCurso(
        matricula,
        cobrancaId
      )

      if (resposta) {
        window.open(resposta.linkBoleto)
      }
      definirPronto(true)
    } catch (erro) {
      definirPronto(true)
      toast('Houve um problema ao obter o boleto', {
        type: 'error'
      })
    }
  }

  const exibirInfoParcelaAtraso = (parcela: DetalheDaParcela) =>
    parcelaEstaEmAtraso(parcela) && parcelaAtiva(parcela)
  const obterDadosRequerimento = async () => {
    try {
      definirPronto(false)

      const dados = await Api.RequisitarDadosRequerimento(requerimentoId)

      if (!dados || dados.tipoRequerimento === 'Licenca') {
        toast(
          'Esta solicitação não possui detalhes na página de requerimentos.',
          { type: 'info' }
        )
        history.goBack()
        return
      }

      definirMatricula(dados.matricula)
      definirRequerimento(dados)
      definirPronto(true)
    } catch (error) {
      definirPronto(true)
    }
  }

  useEffect(() => {
    obterDadosRequerimento()
  }, [])

  return (
    <>
      <Container>
        <ContainerLink>
          <Link
            texto="Voltar"
            icone={IconeBack}
            acaoVoltar={() => history.goBack()}
          />
        </ContainerLink>
        <ContainerMain>
          <Cabecalho>
            <Breadcrumb
              titulo="Detalhes da solicitação de Certificado Impresso"
              atalhos={[
                { texto: 'Requerimentos' },
                { texto: 'Certificado Impresso' }
              ]}
            />
          </Cabecalho>
          <Conteudo>
            {!pronto ? (
              <Carregando texto="Carregando dados..." />
            ) : (
              <>
                <FormUnform
                  ref={formRef}
                  dadosIniciais={requerimento}
                  acaoSucesso={() => {}}
                >
                  <Container>
                    <Linha>
                      <ContainerCheio>
                        <InputUnform
                          name="nome"
                          label="Nome Completo"
                          maxLength={200}
                          obrigatorio
                          disabled
                          style={{ textTransform: 'uppercase' }}
                        />
                      </ContainerCheio>
                    </Linha>
                    <Linha>
                      <ContainerCheio>
                        <InputUnform
                          id="slct_turma"
                          name="turma.nome"
                          label="Turma"
                          disabled
                        />
                      </ContainerCheio>
                    </Linha>

                    <SubMenu>Endereço</SubMenu>
                    <Scope path="endereco">
                      <Linha>
                        <ContainerMedio>
                          <InputUnform
                            id="slc_pais"
                            name="pais"
                            label="País"
                            disabled
                          />
                        </ContainerMedio>
                        <ContainerMedio>
                          <InputUnform
                            id="ipt_cep"
                            name="cep"
                            label="CEP"
                            disabled
                          />
                        </ContainerMedio>
                      </Linha>
                      <Linha>
                        <ContainerGrande>
                          <InputUnform
                            id="ipt_logradouro"
                            name="logradouro"
                            label="Logradouro"
                            obrigatorio
                            maxLength={200}
                          />
                        </ContainerGrande>
                        <ContainerPequeno>
                          <InputUnform
                            id="ipt_numero"
                            name="numero"
                            label="Número"
                            obrigatorio
                            maxLength={10}
                          />
                        </ContainerPequeno>
                      </Linha>
                      <Linha>
                        <ContainerMedio>
                          <InputUnform
                            id="ipt_complemento"
                            name="complemento"
                            label="Complemento"
                            maxLength={200}
                          />
                        </ContainerMedio>
                        <ContainerMedio>
                          <InputUnform
                            id="ipt_bairro"
                            name="bairro"
                            label="Bairro"
                            obrigatorio
                            maxLength={200}
                          />
                        </ContainerMedio>
                      </Linha>
                      <Linha>
                        <ContainerMedio>
                          <InputUnform
                            id="ipt_cidade"
                            name="cidade"
                            label="Cidade"
                            obrigatorio
                            maxLength={200}
                          />
                        </ContainerMedio>
                        <ContainerMedio>
                          <InputUnform
                            id="ipt_uf"
                            name="uf"
                            label="UF"
                            obrigatorio
                          />
                        </ContainerMedio>
                      </Linha>
                    </Scope>
                    <Spacer padding="20px 0px" />
                  </Container>
                </FormUnform>
                <ContainerTabela>
                  <Accordion
                    titulo="Cobrança Requerimento"
                    iniciarAberto={true}
                  >
                    <Tabela
                      Id="tabela-parcelas-curso"
                      key="tabela-parcelas-curso"
                      TemaLinha={(linha: TabelaDados) => {
                        const parcela = (linha as unknown) as DetalheDaParcela
                        switch (parcela.situacaoParcela) {
                          case SituacaoParcela.AguardandoPagamentoAutomatico.toString():
                            return TemaLinha.Atencao

                          case SituacaoParcela.Negativado.toString():
                            return TemaLinha.Negativado

                          case SituacaoParcela.Pago.toString():
                            return TemaLinha.Pago

                          case SituacaoParcela.Renegociado.toString():
                            return TemaLinha.Renegociado

                          case SituacaoParcela.Vencido.toString():
                            return TemaLinha.Erro

                          default:
                            return TemaLinha.Padrao
                        }
                      }}
                      ref={tabelaRef}
                      Colunas={[
                        {
                          Chave: 'valor',
                          Texto: 'Valor',
                          Renderizar: (linha: TabelaDados) => {
                            const parcela = (linha as unknown) as DetalheDaParcela
                            return (
                              <ContainerDoValorDaTabela>
                                <span>{formatadores.moeda(linha.valor)}</span>
                                {exibirInfoParcelaAtraso(parcela) && (
                                  <TooltipParcelaEmAtrasoComEstilos
                                    id={parcela.cobrancaId}
                                    detalhes={
                                      parcela.informacoesParcelaAposVencimento
                                    }
                                  />
                                )}
                                {parcela.observacao && (
                                  <TooltipParcelaObservacaoComEstilos
                                    id={`observacao-${parcela.cobrancaId}`}
                                    observacao={parcela.observacao}
                                  />
                                )}
                                {parcela.observacaoInterna && (
                                  <TooltipParcelaObservacaoComEstilos
                                    id={`observacao-${parcela.cobrancaId}`}
                                    observacao={parcela.observacaoInterna}
                                    interna
                                  />
                                )}
                              </ContainerDoValorDaTabela>
                            )
                          },
                          StyleColuna: { width: 150 }
                        },
                        {
                          Chave: 'dataVencimento',
                          Texto: 'Vencimento',
                          Renderizar: (linha: TabelaDados) => (
                            <>
                              {formatadores.dataLocaleString(
                                linha.dataVencimento
                              )}
                            </>
                          ),
                          StyleColuna: { whiteSpace: 'nowrap' }
                        },
                        {
                          Chave: 'dataPagamento',
                          Texto: 'Data de Pagamento',
                          Renderizar: (linha: TabelaDados) => (
                            <>
                              {formatadores.dataLocaleString(
                                linha.dataPagamento
                              )}
                            </>
                          ),
                          StyleColuna: { width: 110 }
                        },
                        {
                          Chave: 'formaPagamento',
                          Texto: 'Forma de Pagamento',
                          Renderizar: (linha: TabelaDados) => (
                            <>{formatadores.pagamento(linha.formaPagamento)}</>
                          ),
                          StyleColuna: { width: 130 }
                        },
                        {
                          Chave: 'SituacaoParcela',
                          Texto: 'Situação',
                          Renderizar: (linha: TabelaDados) => (
                            <>{SituacaoParcela[linha.situacaoParcela]}</>
                          )
                        },
                        {
                          Chave: 'acoes',
                          Alinhamento: 'center',
                          Renderizar: (linha: TabelaDados) => (
                            <ContainerAcoes>
                              <>
                                {exibirBotaoPagamentoCurso(
                                  linha.situacaoParcela
                                ) && (
                                  <button
                                    type="button"
                                    data-tip="Pagar com Pix"
                                    data-for={`${linha.id}-tooltip`}
                                    onClick={() => {
                                      modalRefPix?.current?.abrir(
                                        linha.cobrancaId,
                                        matricula
                                      )
                                    }}
                                  >
                                    <IconeTabela>{IconePix}</IconeTabela>
                                  </button>
                                )}
                                {exibirBotaoPagamentoCurso(
                                  linha.situacaoParcela
                                ) && (
                                  <button
                                    type="button"
                                    data-tip="Gerar boleto"
                                    data-for={`${linha.id}-tooltip`}
                                    onClick={() =>
                                      gerarBoleto(linha.cobrancaId)
                                    }
                                  >
                                    <IconeTabela>
                                      {IconeGerarBoleto}
                                    </IconeTabela>
                                  </button>
                                )}
                              </>
                              <Tooltip
                                id={`${linha.id}-tooltip`}
                                offset={{ top: 10 }}
                              />
                            </ContainerAcoes>
                          )
                        }
                      ]}
                      ObterDados={obterDadosTabelaParcelasAtivas}
                    />
                  </Accordion>
                </ContainerTabela>
              </>
            )}
          </Conteudo>
        </ContainerMain>
      </Container>
      <ModalPagamentoParaPix
        ref={modalRefPix}
        backdrop
        id="modal-pagamento-pix"
      />
    </>
  )
}

export default (): JSX.Element => (
  <ErroLayoutContainer.Provider>
    <PaginaDetalhesRequerimento />
  </ErroLayoutContainer.Provider>
)
